"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "StripeProvider", {
  enumerable: true,
  get: function get() {
    return _Provider.default;
  }
});
Object.defineProperty(exports, "injectStripe", {
  enumerable: true,
  get: function get() {
    return _inject.default;
  }
});
Object.defineProperty(exports, "Elements", {
  enumerable: true,
  get: function get() {
    return _Elements.default;
  }
});
Object.defineProperty(exports, "PaymentRequestButtonElement", {
  enumerable: true,
  get: function get() {
    return _PaymentRequestButtonElement.default;
  }
});
exports.PostalCodeElement = exports.CardCVCElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = void 0;

var _Provider = babelHelpers.interopRequireDefault(require("./components/Provider"));

var _inject = babelHelpers.interopRequireDefault(require("./components/inject"));

var _Elements = babelHelpers.interopRequireDefault(require("./components/Elements"));

var _Element = babelHelpers.interopRequireDefault(require("./components/Element"));

var _PaymentRequestButtonElement = babelHelpers.interopRequireDefault(require("./components/PaymentRequestButtonElement"));

// @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-flow-strip-types", "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}
// @module-id: stripe-elements
var CardElement = (0, _Element.default)('card', {
  sourceType: 'card'
});
exports.CardElement = CardElement;
var CardNumberElement = (0, _Element.default)('cardNumber', {
  sourceType: 'card'
});
exports.CardNumberElement = CardNumberElement;
var CardExpiryElement = (0, _Element.default)('cardExpiry');
exports.CardExpiryElement = CardExpiryElement;
var CardCVCElement = (0, _Element.default)('cardCvc');
exports.CardCVCElement = CardCVCElement;
var PostalCodeElement = (0, _Element.default)('postalCode');
exports.PostalCodeElement = PostalCodeElement;